import { useState } from 'react';
import { Layout, CtaForm } from '../../components';
import { PLATFORMS, PLATFORMS_CATEGORIES, countCategory } from '../../data/platforms';
import { CONTACT_LINK, API_DOCUMENTATION_LINK } from '../../constants';

export default function Integrations() {
	const [obj, setObj] = useState({
		displayCategory: 'All',
		platforms: PLATFORMS,
		platformsCategories: PLATFORMS_CATEGORIES,
	});

	return (
		<Layout pageName="Integrations">
			<div className="resource-page resource-page--integrations">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">
								<span>Facility</span>Bot Integrations
							</h1>

							<h2 className="heading__desc">
								FacilityBot comes integrated with other systems to provide you with a seamless Smart Facilities
								Management experience
							</h2>

							<div className="heading__integrations">
								Don't see your desired integration here?{' '}
								<a href={CONTACT_LINK} target="_blank" rel="noreferrer">
									Contact us
								</a>{' '}
								to suggest a new integration or discuss customisations or{' '}
								<a href={API_DOCUMENTATION_LINK} target="_blank" rel="noreferrer">
									use our APIs
								</a>{' '}
								to build your custom integration.
							</div>
						</div>
					</div>
				</section>

				<section className="platforms">
					<div className="container">
						<div className="platforms-wrapper">
							<aside className="platforms__sidebar">
								<h3 className="platforms__sidebar-title">Categories</h3>

								<CategoryList
									categories={obj.platformsCategories}
									selectedCategory={(category) => setObj({ ...obj, displayCategory: category })}
								/>
							</aside>

							<PlatformList platforms={obj.platforms} displayCategory={obj.displayCategory} />
						</div>
					</div>
				</section>

				<CtaForm />
			</div>
		</Layout>
	);
}

const PlatformList = ({ platforms, displayCategory }) => {
	return (
		<div className="platforms__main">
			{platforms
				.filter(({ category }) => displayCategory == category || displayCategory == 'All')
				.map((item, index) => (
					<Platform key={index} {...item} />
				))}
		</div>
	);
};

const Platform = ({ title, src, description, status, homepage }) => (
	<article className="platforms__item">
		{homepage ? (
			<a href={homepage} target="_blank" rel="noreferrer" className="platforms__item-title">
				{title}
			</a>
		) : (
			<h2 className="platforms__item-title">{title}</h2>
		)}
		<div className="platforms__item-logo">
			<img src={src} alt="" />
		</div>
		<div className="platforms__item-description" dangerouslySetInnerHTML={{ __html: description }} />
		<div className={`platforms__item-status ${status ? 'active' : 'inactive'}`}>
			{status ? <span>live</span> : <span>upcoming</span>}
		</div>
	</article>
);

const CategoryList = ({ categories, selectedCategory }) => {
	const [activeCategory, setActiveCategory] = useState('All');

	return (
		<ul className="platforms__sidebar-list">
			{categories.map((category, index) => {
				return (
					<Category
						key={index}
						active={category == activeCategory}
						category={category}
						handleClick={() => {
							selectedCategory(category);
							setActiveCategory(category);
						}}
					/>
				);
			})}
		</ul>
	);
};

const Category = ({ category, active, handleClick }) => (
	<li className={`platforms__sidebar-item ${active && 'active'}`} onClick={handleClick}>
		{`${category} (${countCategory(category)})`}
	</li>
);
